import { AppState, AppReducer } from './app';
import { combineReducers, ReducersMapObject, Reducer } from 'redux';
import { PermissionsReducer, IPermissionsState } from './permissions';

export interface RootState {
    app: AppState;
    permissions: IPermissionsState;
}

export const createReducer = <T>(reducers?: ReducersMapObject<T>) =>
    combineReducers<Reducer<RootState & ReducersMapObject<T>>>({
        app: AppReducer,
        permissions: PermissionsReducer,
        ...reducers,
    });
